/**
 * Google Tag Manager / GA4 dataLayer helper
 * Pushes ecommerce events for conversion tracking in Google Ads & GA4
 */

const push = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
};

/**
 * Track "add_to_cart" — user initiates checkout / selects a plan
 */
export const trackAddToCart = ({ planName, planKey, price, currency = 'ILS', billingCycle, numMailboxes, source }) => {
    push({ ecommerce: null }); // Clear previous ecommerce data
    push({
        event: 'add_to_cart',
        ecommerce: {
            currency,
            value: price,
            items: [{
                item_id: planKey || planName,
                item_name: planName,
                item_category: 'Email Plan',
                item_variant: billingCycle || 'monthly',
                price,
                quantity: numMailboxes || 1,
            }],
        },
        billing_cycle: billingCycle,
        num_mailboxes: numMailboxes,
        source: source || 'pricing_page',
    });
};

/**
 * Track "begin_checkout" — payment page opens (iframe loaded)
 */
export const trackBeginCheckout = ({ planName, planKey, price, currency = 'ILS', billingCycle, numMailboxes, transactionId, source }) => {
    push({ ecommerce: null });
    push({
        event: 'begin_checkout',
        ecommerce: {
            currency,
            value: price,
            items: [{
                item_id: planKey || planName,
                item_name: planName,
                item_category: 'Email Plan',
                item_variant: billingCycle || 'monthly',
                price,
                quantity: numMailboxes || 1,
            }],
        },
        transaction_id: transactionId,
        source: source || 'pricing_page',
    });
};

/**
 * Track "purchase" — payment completed successfully
 */
export const trackPurchase = ({ transactionId, planName, planKey, price, currency = 'ILS', billingCycle, numMailboxes, source, proposalNumber }) => {
    push({ ecommerce: null });
    push({
        event: 'purchase',
        ecommerce: {
            transaction_id: transactionId || `txn_${Date.now()}`,
            currency,
            value: price,
            items: [{
                item_id: planKey || planName,
                item_name: planName,
                item_category: 'Email Plan',
                item_variant: billingCycle || 'monthly',
                price,
                quantity: numMailboxes || 1,
            }],
        },
        billing_cycle: billingCycle,
        num_mailboxes: numMailboxes,
        source: source || 'pricing_page',
        proposal_number: proposalNumber || '',
    });
};

/**
 * Track custom conversion event
 */
export const trackEvent = (eventName, params = {}) => {
    push({ event: eventName, ...params });
};
